module.exports = __webpack_public_path__ + "static/media/refcode.a4198459.gif";